import ActionConstants from '../constants/ActionConstants';

// Generate UUID v4
const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (c) => {
    const r = Math.trunc((Math.random() * 16));
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const initialState = {
  isVisible: false,
  messages: [],
  loading: false,
  error: null,
  sessionId: generateUUID(),
};

const chatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionConstants.CHATBOT_TOGGLE_VISIBILITY:
      return {
        ...state,
        isVisible: !state.isVisible,
      };

    case ActionConstants.CHATBOT_ADD_MESSAGE:
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };

    case ActionConstants.CHATBOT_CLEAR_MESSAGES:
      return {
        ...state,
        messages: [],
        sessionId: generateUUID(),
      };

    case ActionConstants.CHATBOT_SEND_MESSAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionConstants.CHATBOT_SEND_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case ActionConstants.CHATBOT_SEND_MESSAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case ActionConstants.CHATBOT_SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};

export default chatbotReducer;
